import React from "react";
import Hero from "@/components/home/Hero";
import Distinction from "@/components/home/Distinction";
import CinematicVideo from "@/components/home/CinematicVideo";
import WhyPublicAdjusters from "@/components/home/WhyPublicAdjusters";
import AGMethod from "@/components/home/AGMethod";
import ByTheNumbers from "@/components/home/ByTheNumbers";
import ClaimServicesGrid from "@/components/home/ClaimServicesGrid";
import FloridaCoverage from "@/components/home/FloridaCoverage";
import NationalPresence from "@/components/home/NationalPresence";
import CaseOutcomes from "@/components/home/CaseOutcomes";
import ResourceCenterPreview from "@/components/home/ResourceCenterPreview";
import Licensing from "@/components/home/Licensing";
import FinalConversion from "@/components/home/FinalConversion";
import useDocumentTitle from "@/lib/useDocumentTitle";

export default function Home() {
  useDocumentTitle("AG Public Adjusting — Florida HQ · National Public Adjusting Firm");
  return (
    <main data-testid="home-page">
      {/* 1. Hero cinematic experience */}
      <Hero />

      {/* 2. The Distinction — what makes AG Public Adjusting different */}
      <Distinction />

      {/* 3. Cinematic brand video — emotional payoff */}
      <CinematicVideo />

      {/* 4. Why Public Adjusters — education + positioning */}
      <WhyPublicAdjusters />

      {/* 5. The AG Method — process credibility */}
      <AGMethod />

      {/* 6. By the Numbers — proof of scale & recovery */}
      <ByTheNumbers />

      {/* 7. Claim Services — coverage breadth */}
      <ClaimServicesGrid />

      {/* 8. Florida Coverage — flagship state */}
      <FloridaCoverage />

      {/* 9. National Presence — 33-state institutional scale */}
      <NationalPresence />

      {/* 10. Case Outcomes — proof of results */}
      <CaseOutcomes />

      {/* 11. Resource Center — thought leadership */}
      <ResourceCenterPreview />

      {/* 12. Licensing & Compliance — trust + regulation */}
      <Licensing />

      {/* 13. Final Conversion — close */}
      <FinalConversion />
    </main>
  );
}
